<script lang="ts" setup>
import AUApi from "@/api";
import { ref, reactive, onMounted, getCurrentInstance, computed } from "vue";
import {
  getDisplay,
  getKennungValueDisplay,
  getKZValueDisplay,
  getKennungValue,
  getKZTitle,
  getValue,
  getKZValue,
  getDisplayValue,
} from "@/DataHelper";
import { Globals } from "../Globals";
import { BaseSetup, mountedBase, reloadData } from "@/DataLoaderStatic";
import { onShowSite, refreshFullPageContent } from "@/NavigationHelper";
import { showDialog, showSnackbar, closeHighestDialog } from "@/UIHelper";
import {
  globalsBezeichnung,
  begriffBezeichnung,
  globalsKennung,
  globalsAic,
} from "@/local";
import DashboardChartsZuordnungenMenu from "@/components/dashboard/Charts/ZuordnungenMenu.vue";
import SpeedDial from "@/components/SpeedDial.vue";
import SubMasken from "@/components/SubMasken.vue";
import { showPDF2 } from "@/PdfHelper";

let lastGroupHeader = "";
let htmlprefixID: number = 0;
const props = defineProps<{
  title?: string;
  query?: string;
  showClose?: boolean;
  Anwesend?: boolean;
  dialog?: boolean;
  showAvatar?: boolean;
  showHeader?: boolean;
  druckItems?: ALLDruck[];
  exportItems?: AbfrageItems[];
  print?: boolean;
  showPrint?: boolean;
  showFilter?: boolean;
  showSpeedDial?: boolean;
  showChart?: boolean;
  showAvatarLeft?: boolean;
  fixHeight?: number;
  edit?: boolean;
  pers?: boolean;
  preloadedData?: any;
  zeitbereich?: APIZeitbereich;
  maxWidth?: number;
  aic?: number;
}>();
const emit = defineEmits<{
  back: any[];
  vector: any[];
  dataloaded: any;
}>();
let filteredItems: ListItems[] = [];
let pagedItems = ref<ListItems[]>([]);
let menu = ref<boolean>(false);
let items = ref<ListItems[]>([]);
let groupedItems: ListItems[] = [];

let filterColumns = ref<FilteredDataColumn[]>([]);
let groupColumns = ref<DataColumn[]>([]);
let groupColumn = ref<DataColumn | null>(null);
let visibleColumn: any[] = [];
let buttonItems: ButtonItems[] = [];
let showQuittMsg = ref<boolean>(false);
let showSelect = ref<boolean>(false);
let selectAll = ref<boolean>(false);
let showChartInternal: boolean = false;
let subForm = ref<string>("");
let mainFrame: string = "";

let pageSize = 10;
let pages = ref<number>(1);
let currentPage = 1;
let fields: any = { id: "id", text: "text", groupBy: "groupBy" };
let avatarIcon: any;
let showAvatar = ref<boolean>(false);
let subHeader = ref<boolean>(false);
let title = ref<string>("");
let searchText = ref<string>("");
let myHeight: number = 300;
let maxWidth = window.innerWidth - 10;

let emptyFilterText: string = "- leer -";
let emptyGroupText: string = "- leer -";
let colorFilter: string = "white";

// eindeutige ID als prefix für die liste erfinden - dass 2 in der selben ms erzeugt werden is extrem unwarscheinlich
let htmlKeyPrefix = htmlprefixID++;

// eindeutige ID generiern mit dem index
function getListItemHtmlId(index: number, asId: boolean = false) {
  return (asId ? "" : "#") + "li" + htmlKeyPrefix + "_" + index;
}

function resetGroupHeader() {
  lastGroupHeader = "xxxxx";
}
function showGroupHeader(item: any) {
  const showit = lastGroupHeader !== item.group;
  lastGroupHeader = item.group;
  return showit;
}

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: props.query,
  preloadedData: props.preloadedData,
  emitBack: () => emit("back"),
};
declare interface BaseListUiData extends DataPageUIData {
  editZeitbereich?: APIZeitbereich;
}

const uiData = reactive<BaseListUiData>(BaseSetup(pageParams));
const hasFormDetail = computed(() => !!uiData.header?.fomDetail);
onMounted(async () => {
  // ich muss das hier überschreiben - sonst wird das datum umgewandelt in einen String mit 23:00 und dann stimmt nichts mehr..
  // wenn aus BaseList (Fehler) - in TimeLineDay und dann wieder BaseList Fehler aufgerufen wird...
  if (props.zeitbereich) {
    pageParams.zeitbereich = props.zeitbereich;
  }
  if (props.aic) {
    // gibt es übergabe AIC - dann zieht der vor!
    pageParams.queryAIC = props.aic;
    pageParams.aic = props.aic;
  }
  if (props.maxWidth) {
    maxWidth = props.maxWidth;
  }
  showChartInternal = props.showChart;
  title.value = globalsBezeichnung(Globals.Begriff, "Web_DatenLaden", "lade...");
  if (props.fixHeight) {
    myHeight = props.fixHeight;
  } else {
    myHeight = window.innerHeight - 200;
  }
  await mountedBase(uiData, pageParams, false);
  if (!uiData.showLoading && uiData.data) {
    await refreshItems();
  }
  uiData.showLoading = false;
  uiData.initialized = true;
  emit("dataloaded", uiData);
});

let checkDetailFormColumnCallback: ((col: DataColumn) => boolean) | undefined;
function checkDetailFormColumn(col: DataColumn): boolean {
  if (checkDetailFormColumnCallback) {
    return checkDetailFormColumnCallback(col);
  }
  return false;
}

function showDetailForm(columns: DataColumn[]) {
  const stt = uiData.header.aicStt;
  buttonItems = [];
  for (let i = 0; i < columns.length; i++) {
    const row = columns[i];
    if (checkDetailFormColumn(row)) {
      // nix weil das macht ne unterkomponente
    } else if (
      (row.meta.subAbf || row.meta.subFom) &&
      !row.meta.invisible &&
      !row.meta.subGra &&
      row.meta.icon
    ) {
      let showCustomEditor = false;
      let compName;
      let compTitle;
      let persFrame = false;
      let query = "";
      let compNameFrm;
      let grid = false;
      if (row.meta.subAbf) {
        query = row.meta.subAbf[0].kennung;
        compTitle = row.meta.subAbf[0].bezeichnung;
        grid = row.meta.tabellenEingabe ?? false;
      } else if (row.meta.subFom) {
        compTitle = row.meta.subFom[0].bezeichnung;
        const subAic = row.meta.subFom[0].aic;
        const sub = globalsAic(Globals.Begriff, subAic);
        if (sub.pers) {
          persFrame = sub.pers;
        }
        if (row.meta.subFom[0].alias) {
          compNameFrm = row.meta.subFom[0].alias;
        } else {
          compNameFrm = row.meta.subFom[0].kennung;
        }
        if (compNameFrm) {
          compName = findComponent(compNameFrm);
        }
        showCustomEditor = true;
      }
      let subFormFullscreen = false;
      if (row.meta && row.meta.subFom && row.meta.subFom[0]) {
        subFormFullscreen = row.meta.subFom[0].fullScreen ?? false;
      }
      if (row.meta.fullScreen) {
        subFormFullscreen = true;
      }
      const fullscreen: boolean = subFormFullscreen ?? false;
      const showCustomGrid = row.meta.tabellenEingabe;
      const width = row.meta.webWidth ?? 455;
      const height = 0;
      const aicEig = row.aicEig;
      const kz = row.meta.kz;
      let color = "primary";
      if (row.meta.farbe) {
        color = row.meta.farbe;
      }
      let icon = "edit";
      if (row.meta.icon) {
        icon = row.meta.icon;
      }
      const tooltip = row.title;
      let toggle = "";
      if (row.kennung) {
        toggle = row.kennung;
      }
      if (kz === "edit" && compNameFrm) {
        if (props.pers && persFrame) {
          subForm.value = compNameFrm;
        } else if (!props.pers && !persFrame) {
          subForm.value = compNameFrm;
        }
      }
      buttonItems.push({
        width,
        height,
        fullscreen,
        showCustomEditor,
        query,
        compName,
        compNameFrm,
        compTitle,
        icon,
        text: 0,
        kz,
        aicEig,
        color,
        toggle,
        tooltip,
        stammtyp: stt,
        grid,
      });
    }
  }
}

function countbooleanFilterableValues(fc: FilteredDataColumn) {
  if (filteredItems) {
    const filteredItemCount = filteredItems?.filter(
      (item) => getValue(item.row, fc) === true
    ).length;

    return (filteredItemCount ?? "??") + "/" + filteredItems.length;
  }
  const setItemCount = items.value?.filter((item) => getValue(item.row, fc) === true)
    .length;

  return (setItemCount ?? "??") + "/" + (items.value?.length ?? "??");
}

function setbooleanFilterValue(fc: FilteredDataColumn) {
  // if (value) {
  //   const jaVal = getDisplayValue(true, fc);
  //   fc.filterValues!.forEach((fv) => (fv.checked = fv.value === jaVal));
  // } else {
  //   fc.filterValues!.forEach((fv) => (fv.checked = true));
  // }
  updateFilteredItems();
}

function findComponent(name: string) {
  const root = getCurrentInstance()?.root;
  name = name.substr(2).replace(/_/g, "").toLowerCase();
  for (const compName in root?.appContext.components) {
    if (compName.toLowerCase().indexOf(name) >= 0) {
      return compName;
    }
  }
  return "";
}
function openFrame(mainFrame: boolean, item?: ListItems) {
  let aic = item?.aic ?? pageParams.queryAIC;
  let site: string = "";
  let tag;
  let fullscreen = false;
  let auswahlQuery = "";
  let neuDialog = "";
  let stammQuery = "";
  if (item && !mainFrame) {
    tag = item.date;
    site = subForm.value;
  } else {
    if (item) {
      uiData.data.aic = item.aic ?? 0;
    }
    if (uiData.header.fomDetail) {
      fullscreen = uiData.header.fomDetail.fullScreen ?? false;
      if (uiData.header.fomDetail.auswahlQuery) {
        stammQuery = uiData.header.fomDetail.stammQuery ?? "";
        auswahlQuery = uiData.header.fomDetail.auswahlQuery ?? "";
        neuDialog = uiData.header.fomDetail.neuDialog ?? "";
        site = "BaseStammMaske";
      }
    }
    tag = uiData.zeitbereich?.von ?? new Date();
  }
  if (tag) {
    const dayIso = new Date(tag);
    const dialogZeitbereich = {
      von: dayIso,
      bis: dayIso,
      bereich: "Tag",
    };
    const navData = {
      zeitbereich: dialogZeitbereich,
      onReloadData: false,
      goDate: tag,
      aic,
      stammQuery,
      auswahlQuery,
      neuDialog,
    };
    if (site === "SoftTermBuchungen" || site === "BaseStammMaske") {
      // aktuellen (obersten) Dialog schließen, bevor wir navigieren
      if (site === "SoftTermBuchungen") {
        closeHighestDialog(true);
      }
      onShowSite({
        title: "",
        site,
        data: navData,
        callOnLeave: () => {
          if (navData.onReloadData === true) {
            setTimeout(() => refreshFullPageContent());
          }
        },
      });
    } else {
      showDialog({
        title: "",
        showTitle: false,
        site,
        data: navData,
        fullscreen,
        width: 450,
        onClose: () => {
          return true;
        },
      });
    }
  } else {
    return;
  }
}
function dynamicSort(property: any) {
  let sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return (a: any, b: any) => {
    const result =
      a[property].localeCompare < b[property].localeCompare
        ? -1
        : a[property].localeCompare > b[property].localeCompare
        ? 1
        : 0;
    return result * sortOrder;
  };
}
function quittMsg(sb: any) {
  if (sb || (items.value && items.value.length > 0)) {
    if (props.pers) {
      AUApi.Current.user.msg = AUApi.Current.user.msg - 1;
    } else {
      AUApi.Current.user.adminMsg = AUApi.Current.user.adminMsg - 1;
    }
    const vecStammLocal: any[] = [];
    if (sb) {
      vecStammLocal.push(sb);
    } else if (items.value && items.value.length > 0) {
      items.value.forEach((x) => {
        vecStammLocal.push(x.aic);
      });
    }
    AUApi.Current.quittMessage(vecStammLocal)?.then((res: any) => {
      if (res) {
        const msgType = res.data.msgType;
        let info = res.data.info;
        const memo = res.data.memo;
        const title = res.data.titel;
        if (memo) {
          info = memo;
        }
        if (info) {
          if (msgType === "Error") {
            showSnackbar({
              text: info,
              color: "error",
            });
          } else if (msgType === "Info") {
            showSnackbar({
              text: info,
              color: "info",
            });
          } else if (msgType === "Warnung") {
            showSnackbar({
              text: info,
              color: "warning",
            });
          }
        }
      }
    });
  }
}
async function refreshItems() {
  try {
    groupColumns.value = uiData.columns.filter(
      (c: any) => c.meta.gruppierbar === true && !c.meta.invisible
    );
    if (groupColumns.value) {
      const rows = [...groupColumns.value];
      if (rows && rows.length > 0 && rows[0].meta) {
        const meta = rows[0].meta;
        if (meta.pGruppiert === true) {
          groupColumnChanged(groupColumns.value[0]);
        }
      }
    }
    title.value = uiData.header.bezeichnung ?? "";
    if (uiData.header.fomDetail) {
      mainFrame = uiData.header.fomDetail.alias ?? uiData.header.fomDetail.kennung;
    }
    // count = data.data.header.zeilen;
    const filterColumnsLocal: FilteredDataColumn[] = (filterColumns.value = uiData.columns.filter(
      (c: any) => c.meta.filterOK === true && !c.meta.invisible && !c.meta.banned
    ));
    visibleColumn = uiData.columns.filter(
      (c: any) => c.meta.invisible !== true && !c.meta.banned
    );
    items.value = [];

    showDetailForm(uiData.columns);
    for (let i = 0; i < uiData.data.length; i++) {
      const row = uiData.data[i];

      if (filterColumnsLocal.length > 0) {
        filterColumnsLocal.forEach((fc, ix) => {
          if (!fc.filterValues) {
            fc.filterValues = [];
          }

          const filterVal = getDisplay(row, fc) ?? emptyFilterText;
          if (filterVal === "<img src='/3_Ampel.png' alt='3' />") {
            // abweichendes neues ICON??
          }
          const filterAic = getValue(row, fc, true);

          const setFilter = fc.meta.value;
          const isCheckbox = fc.type === "checkBox";
          if (isCheckbox && fc.filterValues.length === 0) {
            fc.filterValues.push({
              checked: setFilter?.length === 1 && setFilter[0] === true,
              value: filterVal,
            });
            fc.filterSwitchValue = setFilter?.length === 1 && setFilter[0] === true;
            return;
          }

          if (filterVal) {
            if (!fc.filterValues.find((f: any) => f.value === filterVal)) {
              let checked = true;
              if (setFilter) {
                if (setFilter.indexOf(filterAic) >= 0) {
                  checked = true;
                  if (isCheckbox && filterAic) {
                    fc.filterSwitchValue = isCheckbox; // setzen wenn true und checkbox
                  }
                } else {
                  checked = false;
                }
              }
              fc.filterValues.push({
                checked,
                value: filterVal,
                aic: filterAic,
              });
            }
            fc.filterValues.sort(dynamicSort("value"));
          }
        });
      }
      let title = getKZValueDisplay(row, "titel", visibleColumn);
      let texttitle;
      if (!title) {
        title = getKZValueDisplay(row, "titel_titel", visibleColumn);
        if (title) {
          texttitle = getKZTitle(row, "titel_titel", visibleColumn);
        }
      }
      let subtitel = getKZValueDisplay(row, "subtitel", visibleColumn);
      let textsubtitel;
      if (!subtitel) {
        subtitel = getKZValueDisplay(row, "subtitel_titel", visibleColumn);
        if (subtitel) {
          textsubtitel = getKZTitle(row, "subtitel_titel", visibleColumn);
        }
      }
      let icon = getKZValueDisplay(row, "icon", visibleColumn);

      if (icon === "warning") {
        icon = "mdi-alert-circle";
      } else if (icon == "error") {
        icon = "mdi-alert";
      }
      const text = getKZValueDisplay(row, "text", visibleColumn);
      let edit = getKZValue(row, "edit", visibleColumn, false, true);
      if (edit === "") {
        edit = false;
      }
      const modell = getKZValue(row, "modell", visibleColumn, false, true);
      const modell1 = getKZValue(row, "modell1", visibleColumn, false, true);
      const checkbox = getKZValueDisplay(row, "checkbox", visibleColumn);
      let ampel = getKZValueDisplay(row, "ampel", visibleColumn);
      let ampelDaten;
      if (props.Anwesend) {
        ampel = getKZValueDisplay(row, "icon", visibleColumn);
        ampelDaten = getKZValue(row, "icon", visibleColumn);
        icon = "";
      } else {
        ampelDaten = getKZValue(row, "ampel", visibleColumn);
      }
      let ampelColor = "grey";
      if (ampelDaten === 0) {
        ampelColor = "grey";
      } else if (ampelDaten === 1) {
        ampelColor = "green";
      } else if (ampelDaten === 2) {
        ampelColor = "orange";
      } else if (ampelDaten === 3) {
        ampelColor = "red";
      }
      if (!props.Anwesend && !props.showFilter) {
        const date = getKZValueDisplay(row, "header", visibleColumn); // TODO Kennung
        const gueltigkeit = getKennungValue(row, "VALIDITY", visibleColumn);
        const color = getKZValueDisplay(row, "color", visibleColumn);
        const pdf = getKZValue(row, "pdf", visibleColumn);
        let aic = getKZValue(row, "modellAic", visibleColumn);
        if (aic === "") {
          aic = undefined;
        }
        let quittMsg = false;
        const existMsg = getKZTitle(row, "quittMsg", visibleColumn);
        if (existMsg) {
          showQuittMsg.value = true;
          quittMsg = false;
        }
        let select = false;
        const selectAic = getKZTitle(row, "select", uiData.columns);
        if (selectAic) {
          showSelect.value = true;
          select = false;
        }
        row.title = getKZValueDisplay(row, "FEHLER", visibleColumn);
        row.subtitle = getKZValueDisplay(row, "MEMO", visibleColumn);
        if (date) {
          // gibt es kein Datum zum Anzeigen, dann darf die Zeile auch nicht erzeugt werden
          items.value.push({ header: date });
        }
        items.value.push({
          title,
          subtitel,
          text,
          color: color ?? ampelColor,
          icon,
          modell,
          modell1,
          edit,
          aic,
          ampel,
          pdf,
          checkbox,
          row,
          group: "",
          divider: true,
          quittMsg,
          select,
          date: gueltigkeit,
        });
      } else {
        let avatar = getKZValue(row, "avatar", visibleColumn);
        const header = getKZValueDisplay(row, "header", visibleColumn);
        const memo = getKZValueDisplay(row, "MEMO", visibleColumn);
        const errorbtn = getKZValue(row, "errorbtn", visibleColumn);
        const warningbtn = getKZValue(row, "warningbtn", visibleColumn);
        const watchbtn = getKZValue(row, "watchbtn", visibleColumn);
        const starbtn = getKZValue(row, "starbtn", visibleColumn);
        const calendarbtn = getKZValue(row, "calendarbtn", visibleColumn);
        const reisebtn = getKZValue(row, "reisebtn", visibleColumn);
        const eurobtn = getKZValue(row, "eurobtn", visibleColumn);
        const pdf = getKZValue(row, "pdf", visibleColumn);
        const receiptbtn = getKZValue(row, "receiptbtn", visibleColumn);
        let aic = getKZValue(row, "modellAic", visibleColumn);
        if (!aic || aic === undefined) {
          if (row.aic_Bew_pool) {
            aic = row.aic_Bew_pool;
          } else {
            aic = row.aic_Stamm;
          }
        }
        const auftrag = getKZValueDisplay(row, "Auftrag", visibleColumn);
        let textAuftrag = "";
        if (auftrag) {
          textAuftrag = getKZTitle(row, "Auftrag", visibleColumn);
        }
        const taetigkeit = getKZValueDisplay(row, "Taetigkeit", visibleColumn);
        let quittMsg = false;
        const existMsg = getKZTitle(row, "quittMsg", visibleColumn);
        if (existMsg) {
          quittMsg = true;
        }
        let select = false;
        const selectAic = getKZTitle(row, "select", uiData.columns);
        if (selectAic) {
          showSelect.value = true;
          select = false;
        }
        let textTaetigkeit = "";
        if (taetigkeit) {
          textTaetigkeit = getKZTitle(row, "Taetigkeit", visibleColumn);
        }
        const handy = getKennungValueDisplay(row, "firmenHandy", uiData.columns);
        const handyHref = "tel:" + handy;
        const telefon = getKZValueDisplay(row, "telefon", visibleColumn);
        const dw = getKennungValueDisplay(row, "INTERNE_DW", visibleColumn);
        const telHref = "tel:" + telefon + dw;

        if (avatar) {
          showAvatar.value = true;
          if (avatar.data) {
            avatar = avatar.data;
          } else {
            loadImage(avatar);
            avatar = avatarIcon;
          }
        }
        // let buttonItemsLocal: any[] = [];
        if (buttonItems && buttonItems.length > 0) {
          buttonItems = JSON.parse(JSON.stringify(buttonItems)); // [...buttonItems];
          for (let j = 0; j < buttonItems.length; j++) {
            buttonItems[j].aic = aic;
            buttonItems[j].text = 0;
            if (buttonItems[j].kz === "errorbtn") {
              if (errorbtn) {
                buttonItems[j].text = errorbtn;
              }
            } else if (buttonItems[j].kz === "watchbtn") {
              if (watchbtn) {
                buttonItems[j].text = watchbtn;
              }
            } else if (buttonItems[j].kz === "starbtn") {
              if (starbtn) {
                buttonItems[j].text = starbtn;
              }
            } else if (buttonItems[j].kz === "calendarbtn") {
              if (calendarbtn) {
                buttonItems[j].text = calendarbtn;
              }
            } else if (buttonItems[j].kz === "eurobtn") {
              if (eurobtn) {
                buttonItems[j].text = eurobtn;
              }
            } else if (buttonItems[j].kz === "warningbtn") {
              if (warningbtn) {
                buttonItems[j].text = warningbtn;
              }
            } else if (buttonItems[j].kz === "reisebtn") {
              if (reisebtn) {
                buttonItems[j].text = reisebtn;
              }
            } else if (buttonItems[j].kz === "receiptbtn") {
              if (receiptbtn) {
                buttonItems[j].text = receiptbtn;
              }
            } else {
              buttonItems[j].text = undefined;
            }
          }
        }
        if (props.Anwesend) {
          items.value.push({
            header,
            title,
            texttitle,
            subtitel,
            textsubtitel,
            text,
            memo,
            avatar,
            ampel,
            icon,
            modell,
            modell1,
            edit,
            checkbox,
            aic,
            menu: false,
            mail: getKennungValueDisplay(row, "E-MAIL", visibleColumn),
            handy,
            telHref,
            handyHref,
            telefon,
            dw,
            auftrag,
            textAuftrag,
            taetigkeit,
            textTaetigkeit,
            row,
            group: "",
            buttonItems,
            quittMsg,
            select,
            color: ampelColor,
          });
        } else {
          items.value.push({
            header,
            title,
            texttitle,
            subtitel,
            textsubtitel,
            text,
            memo,
            avatar,
            ampel,
            icon,
            modell,
            modell1,
            edit,
            checkbox,
            aic,
            auftrag,
            textAuftrag,
            taetigkeit,
            textTaetigkeit,
            row,
            group: "",
            buttonItems,
            quittMsg,
            select,
            color: ampelColor,
            pdf,
          });
        }
      }
    }
  } finally {
    // daten werden an baseChartList übergeben - damit die Charts angezeigt werden können
    if (items.value) {
      if (items.value.length > 0) {
        if (uiData.header?.pagAnzahl) {
          pageSize = uiData.header.pagAnzahl;
        }
        filteredItems = items.value;
        // man muss aufrunden!
        pages.value = Math.max(1, Math.ceil(filteredItems.length / pageSize));
        const instance = getCurrentInstance();
        // vielleicht mit instance lösbar?
        // if (BaseList.lastQuery === props.query) {
        //   if (pages > BaseList.lastPage) {
        //     currentPage = BaseList.lastPage;
        //   } else {
        //     currentPage = BaseList.lastPage = 1;
        //     BaseList.lastQuery = props.query;
        //   }
        // } else {
        //   currentPage = BaseList.lastPage = 1;
        //   BaseList.lastQuery = props.query;
        // }
        if (lastQuery === props.query) {
          if (pages.value > lastPage) {
            currentPage = lastPage;
          } else {
            currentPage = lastPage = 1;
            lastQuery = props.query;
          }
        } else {
          currentPage = lastPage = 1;
          lastQuery = props.query;
        }
        updateFilteredItems();
      }
    }
  }
}

let lastPage: number = 1;
let lastQuery: string | undefined;

function updatePagedItems() {
  lastPage = currentPage;
  lastQuery = props.query;
  const startIndex = (currentPage - 1) * pageSize;
  pagedItems.value = [];
  pagedItems.value = filteredItems.slice(
    startIndex,
    Math.min(filteredItems.length, startIndex + pageSize)
  );
}

function updateFilteredItems() {
  colorFilter = "white";
  if (!filterColumns.value && !searchText.value) {
    if (items.value) {
      filteredItems = items.value;
    } else {
      filteredItems = [];
    }
    return;
  }
  let oldPagePos = currentPage / Math.max(1, pages.value);
  // war durch den Filter nur 1 Seite
  // dann muss ich wenn wieder alle angezeigt werden sollen - auf die erste Seite zurück!
  if (currentPage === pages.value) {
    oldPagePos = 0;
  }
  filteredItems = [];
  if (items.value) {
    filteredItems = items.value.filter((item) => {
      let match = true;
      if (groupColumn.value) {
        item.group = getDisplay(item.row, groupColumn.value);
        if (!item.group || item.group === "") {
          item.group = emptyGroupText;
        }
      }

      if (searchText.value) {
        colorFilter = "green";
        const search = searchText.value.toLowerCase();
        const inHeader = item.header && item.header.toLowerCase().indexOf(search) >= 0;
        const inTitle = item.title && item.title.toLowerCase().indexOf(search) >= 0;
        const inSub =
          item.subtitel != null && item.subtitel.toLowerCase().indexOf(search) >= 0;
        if (!inHeader && !inTitle && !inSub) {
          return false;
        }
      }

      if (!filterColumns.value) {
        return true;
      }
      // for (let i = 0; i < me.filterColumns.value.length; i++) {
      filterColumns.value.forEach((fc) => {
        const fv = getDisplay(item.row, fc) ?? emptyFilterText;

        if (fc.type === "checkBox") {
          if (fc.filterSwitchValue) {
            colorFilter = "green";
            // wenn nicht dann alle
            const jaVal = getDisplayValue(true, fc);
            match = match && jaVal === fv;
          }
        } else {
          const checkFilter = fc.filterValues?.find((ffv: any) => !ffv.checked);
          if (checkFilter) {
            colorFilter = "green";
          }
          match =
            match &&
            fc.filterValues?.find((ffv: any) => ffv.value === fv && ffv.checked) != null;
        }
      });
      return match;
    });
  }
  if (groupColumn.value) {
    filteredItems = filteredItems.sort((a, b) => {
      if (a.group > b.group) {
        return 1;
      } else if (b.group > a.group) {
        return -1;
      }
      return 0;
    });
  }
  pages.value = Math.max(1, Math.ceil(filteredItems.length / pageSize));
  currentPage = Math.max(Math.floor(pages.value * oldPagePos), 1);

  updateGroupedItems();
}

function filterChanged() {
  updateFilteredItems();
}

function loadImage(avatar: any) {
  if (avatar.data) {
    // dann passt es
  } else {
    avatarIcon = AUApi.Current.fullUrl(
      "imageM/" + AUApi.Current.user.id + ":" + +avatar.aic + "_" + avatar.name
    );
  }
}
function onShowPdf(pdf: any) {
  showPDF2(pdf.name, pdf.aic, AUApi.Current.user.id);
  const varUbergabe: VarUebergabe[] = [];
  const tabUbergabe: any[] = [];
  const begriff = globalsKennung(Globals.Begriff, "Web_Dokumente_gedrucktsetzen");
  const bemerkung: string = "WEB - baseList";
  if (begriff.aic) {
    AUApi.Current.postCalc(
      varUbergabe,
      tabUbergabe,
      begriff.aic,
      0,
      pageParams.zeitbereich,
      0,
      0,
      bemerkung,
      success,
      begriff.maxB,
      [],
      uiData.data[0].aic_Bew_pool
    );
    reloadData(uiData, pageParams);
  }
}
async function success(res: any) {
  await reloadData(uiData, pageParams);
}
function checkChanged(fv: any) {
  fv.checked = !fv.checked;
  filterChanged();
}
function groupColumnChanged(gv?: DataColumn) {
  if (gv === groupColumn.value) {
    gv = undefined;
  }

  groupColumn.value = gv ?? null;
  updateFilteredItems();
}
function updateGroupedItems() {
  if (groupColumn.value != null) {
    subHeader.value = true;

    if (filteredItems.length > 0) {
      groupedItems = filteredItems.slice();
    } else {
      // 14.8.2023 wenn alle Gruppierungen weggeschalten sind nicht ALLE MA anzeigen...
      subHeader.value = false;
      groupedItems = filteredItems;
      // if (items && items.length > 0) {
      //   groupedItems = items.slice();
      // }
    }

    filteredItems = groupedItems;
  } else {
    subHeader.value = false;
    groupedItems = filteredItems;
  }
  updatePagedItems();
}
function setUserPara() {
  const varUbergabe: VarUebergabe[] = [];
  let value: any[] = [];
  const cols = filterColumns.value;
  if (cols && cols.length > 0) {
    for (let i = 0; i < cols.length; i++) {
      if (cols[i].type === "checkBox") {
        varUbergabe.push({
          aic: cols[i].aic,
          value: [cols[i].filterSwitchValue ?? false],
        });
        continue;
      }
      const filterItems = cols[i].filterValues ?? [];
      value = [];
      const valueList = filterItems.filter((c: any) => c.checked === true);
      for (let j = 0; j < valueList.length; j++) {
        if (valueList[j].aic || valueList[j].aic === 0) {
          value.push(valueList[j].aic);
        }
      }
      varUbergabe.push({
        aic: cols[i].aic,
        value,
      });
    }
  }
  if (groupColumns) {
    if (groupColumn.value) {
      varUbergabe.push({
        aic: groupColumn.value?.aic ?? 0,
        pGruppiert: true,
      });
    } else if (groupColumns.value && groupColumns.value.length > 0) {
      varUbergabe.push({
        aic: groupColumns.value[0].aic,
        pGruppiert: false,
      });
    }
  }
  colorFilter = "green";
  AUApi.Current.setPersParameter(varUbergabe);
}
async function deleteUserPara() {
  colorFilter = "white";
  const aicBegriff = uiData.header.aicBegriff;
  AUApi.Current.deletePersParameter(aicBegriff);
  groupColumns.value = [];
  groupColumnChanged();
  await reloadData(uiData, pageParams);
  await refreshItems(); // es soll alles auf Original zurück gesetzt werden
}
async function resetFilter() {
  if (filterColumns.value && filterColumns.value.length > 0) {
    filterColumns.value.forEach((fc: any, ix) => {
      if (fc.type === "checkBox") {
        fc.filterSwitchValue = false;
      }
      if (fc.filterValues.length > 0) {
        for (let j = 0; j < fc.filterValues.length; j++) {
          fc.filterValues[j].checked = true;
        }
      }
    });
  }
  colorFilter = "white";
  searchText.value = "";
  await refreshItems();
  groupColumnChanged();
  updateFilteredItems();
}
function selectChange(val: any) {
  const select = val.select;
  if (select) {
    if (!pageParams.vecStamm) {
      pageParams.vecStamm = [];
    }
    pageParams.vecStamm.push(val.aic);
  } else {
    if (pageParams.vecStamm) {
      pageParams.vecStamm = pageParams.vecStamm.filter((c: any) => c.aic === val.aic);
    }
  }
  emit("vector", pageParams.vecStamm);
}
function selectChangeAll(data: any) {
  if (data) {
    if (filteredItems) {
      pageParams.vecStamm = [];
      for (let i = 0; i < filteredItems.length; i++) {
        const row = filteredItems[i];
        pageParams.vecStamm.push(row.aic ?? 0);
        filteredItems[i].select = true;
      }
    }
  } else {
    pageParams.vecStamm = [];
    if (filteredItems) {
      for (let i = 0; i < filteredItems.length; i++) {
        const row = filteredItems[i];
        filteredItems[i].select = false;
      }
    }
  }
  emit("vector", pageParams.vecStamm);
}

declare interface ButtonItems {
  aic?: number;
  width?: number;
  height?: number;
  fullscreen: boolean;
  showCustomEditor: boolean;
  query: string;
  compName?: string;
  compNameFrm?: string;
  compTitle?: string;
  icon: string;
  text?: number;
  kz?: string;
  aicEig?: number;
  color: string;
  toggle: string;
  tooltip: string;
  stammtyp?: number;
  grid?: boolean;
}
</script>
<template>
  <v-card density="compact" flat tile :loading="uiData.showLoading" :max-width="maxWidth">
    <v-toolbar
      v-if="props.showHeader"
      style="height: 60px"
      class="dvhBackground mb-02"
      dark
      :max-width="maxWidth"
    >
      <v-toolbar-title v-if="title" style="color: white">
        {{ title }}
      </v-toolbar-title>
      <v-spacer v-if="showSelect"></v-spacer>
      <v-checkbox
        dark
        style="color: white"
        v-if="showSelect"
        @update:modelValue="selectChangeAll"
        class="pr-5 pt-5"
        :label="globalsBezeichnung(Globals.Begriff, 'alle', 'alle')"
        v-model="selectAll"
      ></v-checkbox>
      <DashboardChartsZuordnungenMenu
        v-if="!props.showSpeedDial && props.druckItems && props.druckItems.length > 0"
        :printItems="props.druckItems"
        :showButtons="true"
        :color="'white'"
        :noSelect="true"
        :zeitbereich="pageParams.zeitbereich"
      />

      <!-- Filter Menü -->
      <v-menu
        v-model="menu"
        v-if="
          filterColumns &&
          filterColumns.length > 0 &&
          (props.Anwesend || props.showFilter)
        "
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props">
            <v-icon :color="colorFilter">mdi-filter-variant</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="resetFilter()" prepend-icon="mdi-restart">
              {{ begriffBezeichnung("Web_Reset") }}
            </v-btn>
            <v-btn variant="text" @click.stop="menu = false" prepend-icon="mdi-cancel">
              {{ begriffBezeichnung("Close") }}
            </v-btn>
          </v-card-actions>

          <v-text-field
            class="px-2"
            :label="globalsBezeichnung(Globals.Begriff, 'Suche', 'Suche')"
            variant="outlined"
            append-inner-icon="mdi-magnify"
            :hide-details="true"
            v-model="searchText"
            @input="updateFilteredItems()"
          ></v-text-field>

          <div class="overflow-y-auto" style="max-height: 600px">
            <div class="ma-2" v-for="(fc, ix) in filterColumns" :key="'fc' + ix">
              <v-list v-if="fc.type !== 'checkBox'" class="pa-0">
                <v-list-item>
                  <v-list-item-title
                    ><v-icon>mdi-filter-variant</v-icon> {{ fc.title }}</v-list-item-title
                  >
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <div v-if="fc.type === 'checkBox'" class="pa-0">
                <v-list class="baselistFilterItems">
                  <v-list-item>
                    <v-list-item-title>
                      <v-switch
                        prepend-icon="filter_list"
                        v-if="fc.type === 'checkBox'"
                        v-model="fc.filterSwitchValue"
                        color="warning"
                        @update:modelValue="setbooleanFilterValue(fc)"
                      >
                        <template v-slot:label>
                          {{ fc.title }} ({{ countbooleanFilterableValues(fc) }})
                        </template>
                      </v-switch>
                      <span v-else>
                        <v-icon>mdi-filter-variant</v-icon>{{ fc.title }}</span
                      >
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </div>
              <div v-if="fc.type !== 'checkBox'">
                <v-list class="baselistFilterItems">
                  <v-list-item
                    v-for="(fv, iix) in fc.filterValues"
                    :key="'fv' + ix + '_' + iix"
                    @click="checkChanged(fv)"
                    title=""
                  >
                    <template v-slot:prepend>
                      <v-icon v-if="!fv.checked">mdi-checkbox-blank-outline</v-icon>
                      <v-icon color="primary" v-if="fv.checked"
                        >mdi-checkbox-outline</v-icon
                      >
                    </template>
                    <v-list-item-title>
                      <span v-html="fv.value"></span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </div>
            </div>
            <div v-if="groupColumns && groupColumns.length > 0">
              <v-list class="pa-0">
                <v-list-item>
                  <template v-slot:prepend>
                    <v-icon>mdi-format-list-group</v-icon>
                  </template>
                  <v-list-item-title>{{
                    begriffBezeichnung("Web_gruppieren")
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-list class="baselistFilterItems">
                <v-list-item
                  v-for="(gv, iix) in groupColumns"
                  :key="'gv' + iix"
                  @click="groupColumnChanged(gv)"
                >
                  <template v-slot:prepend>
                    <v-icon v-if="gv != groupColumn">mdi-checkbox-blank-outline</v-icon>
                    <v-icon color="primary" v-if="gv == groupColumn"
                      >mdi-checkbox-outline</v-icon
                    >
                  </template>

                  <v-list-item-title>
                    <span v-html="gv.title"></span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </div>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              variant="text"
              color="green"
              @click.stop="setUserPara()"
              prepend-icon="mdi-filter"
              :text="
                globalsBezeichnung(Globals.Begriff, 'Web_Einst_Speichern', 'Speichern')
              "
            >
            </v-btn>
            <v-btn
              variant="text"
              color="red"
              @click.stop="deleteUserPara()"
              prepend-icon="mdi-filter-remove"
              :text="
                globalsBezeichnung(
                  Globals.Begriff,
                  'Web_Einstellungen_Loeschen',
                  'Löschen'
                )
              "
            >
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-btn
        v-if="props.showClose"
        color="white"
        icon="mdi-close"
        @click="emit('back')"
      ></v-btn>
    </v-toolbar>
    <v-card-text v-if="pagedItems.length === 0 && !uiData.showLoading">
      {{ begriffBezeichnung("Web_keineDaten_gefunden", "keine Daten gefunden") }}
    </v-card-text>
    <v-list
      v-if="(props.Anwesend || props.showFilter) && !subHeader && uiData.initialized"
      lines="three"
    >
      <v-list-item
        ref="liste"
        v-for="(item, index) in pagedItems"
        :key="'c' + index"
        :id="getListItemHtmlId(index, true)"
        :ripple="props.Anwesend || hasFormDetail"
        :tabindex="props.Anwesend || hasFormDetail ? 0 : -1"
        :aria-disabled="!(props.Anwesend || hasFormDetail)"
        variant="outlined"
        tile
        :class="['pr-0', { 'no-click': !(props.Anwesend || hasFormDetail) }]"
      >
        <template #prepend>
          <div class="d-none d-sm-flex">
            <v-icon v-if="item.ampel" size="x-large" :color="item.color" class="mr-2">
              mdi-circle-slice-8
            </v-icon>

            <v-img
              v-else-if="item.icon"
              :src="item.icon"
              max-width="24"
              max-height="24"
              class="mr-2"
            />

            <v-avatar
              v-else-if="showAvatar && props.showAvatarLeft && item.avatar !== undefined"
              size="32"
              class="mr-2"
            >
              <v-img v-if="item.avatar" :src="item.avatar" />
              <v-icon v-else size="32" color="grey">mdi-account-circle</v-icon>
            </v-avatar>
          </div>
        </template>

        <!-- APPEND: Desktop -->
        <template v-slot:append>
          <v-list-item-action class="flex-column align-end d-none d-sm-flex">
            <v-avatar
              v-if="showAvatar && !props.showAvatarLeft && props.showAvatar"
              class="pr-2"
            >
              <v-img v-if="item.avatar" :src="item.avatar" size="48" />
              <v-icon v-else size="48" color="grey">mdi-account-circle</v-icon>
            </v-avatar>

            <div v-if="item.pdf && showSelect && item.aic" class="d-flex align-center">
              <v-btn
                density="comfortable"
                size="large"
                class="ma-5"
                @click="onShowPdf(item.pdf)"
                variant="outlined"
              >
                <v-icon>mdi-file-pdf-box</v-icon>{{ item.pdf.name }}
              </v-btn>
              <v-checkbox
                v-model="item.select"
                @update:modelValue="selectChange(item)"
                hide-details
                class="ml-2"
              ></v-checkbox>
            </div>
            <v-checkbox
              v-else-if="showSelect && item.aic"
              v-model="item.select"
              @update:modelValue="selectChange(item)"
              hide-details
            ></v-checkbox>

            <SpeedDial
              v-if="props.showSpeedDial"
              :aic="item.aic"
              :modell="item.modell"
              :modell1="item.modell1"
              :exportItems="props.exportItems"
              :printItems="props.druckItems"
              :print="props.print"
              :editDialog="item.edit"
              :setEdit="false"
              direction="left"
              :pers="pers"
            ></SpeedDial>
          </v-list-item-action>
        </template>

        <v-list-item-title
          class="d-flex justify-content-between align-center w-100"
          @click="
            hasFormDetail ? openFrame(true, item) : props.Anwesend && (item.menu = true)
          "
        >
          <div class="d-flex align-center">
            <div class="d-flex align-center d-sm-none mr-2">
              <v-icon v-if="item.ampel" size="large" :color="item.color" class="mr-2">
                mdi-circle-slice-8
              </v-icon>

              <v-img
                v-else-if="item.icon"
                :src="item.icon"
                max-width="20"
                max-height="20"
                class="mr-2"
              />

              <v-avatar
                v-else-if="
                  showAvatar && props.showAvatarLeft && item.avatar !== undefined
                "
                size="24"
              >
                <v-img v-if="item.avatar" :src="item.avatar" />
                <v-icon v-else size="24" color="grey">mdi-account-circle</v-icon>
              </v-avatar>
            </div>
            {{ item.header }}
          </div>

          <!-- Rechte Seite: Mobile Inline (Checkbox + SpeedDial + Avatar nebeneinander) -->
          <div class="d-flex align-center d-sm-none ml-auto">
            <v-avatar
              v-if="showAvatar && !props.showAvatarLeft && props.showAvatar"
              class="mr-2"
            >
              <v-img v-if="item.avatar" :src="item.avatar" size="36" />
              <v-icon v-else size="36" color="grey">mdi-account-circle</v-icon>
            </v-avatar>

            <v-checkbox
              v-if="showSelect && item.aic"
              v-model="item.select"
              @update:modelValue="selectChange(item)"
              hide-details
              class="mr-2"
            ></v-checkbox>

            <SpeedDial
              v-if="props.showSpeedDial"
              :aic="item.aic"
              :modell="item.modell"
              :modell1="item.modell1"
              :exportItems="props.exportItems"
              :printItems="props.druckItems"
              :print="props.print"
              :editDialog="item.edit"
              :setEdit="false"
              direction="left"
              :pers="pers"
            ></SpeedDial>
          </div>
        </v-list-item-title>

        <div
          v-if="(item.texttitle || item.textsubtitel) && !props.Anwesend"
          @click="
            hasFormDetail ? openFrame(true, item) : props.Anwesend && (item.menu = true)
          "
        >
          <v-row class="pa-0 mt-2" v-if="item.texttitle">
            <v-col cols="3" class="py-1">
              <v-list-item-subtitle> {{ item.texttitle }}</v-list-item-subtitle> </v-col
            ><v-col cols="9" class="py-1">
              <v-list-item-subtitle style="text-align: right"
                >{{ item.title }}
              </v-list-item-subtitle>
            </v-col>
          </v-row>
          <v-row class="pa-0" v-if="item.textsubtitel">
            <v-col cols="3" class="py-1">
              <v-list-item-subtitle>
                {{ item.textsubtitel }}</v-list-item-subtitle
              > </v-col
            ><v-col cols="9" class="py-1">
              <v-list-item-subtitle style="text-align: right"
                >{{ item.subtitel }}
              </v-list-item-subtitle>
            </v-col>
          </v-row>
        </div>
        <div
          style="min-height: 50px"
          @click="
            hasFormDetail ? openFrame(true, item) : props.Anwesend && (item.menu = true)
          "
        >
          <v-list-item-subtitle v-if="item.title && !item.texttitle">
            {{ item.title }}</v-list-item-subtitle
          >
          <v-list-item-subtitle v-if="item.subtitel && !item.textsubtitel"
            >{{ item.subtitel }}
          </v-list-item-subtitle>
          <v-list-item-subtitle v-if="item.text">{{ item.text }} </v-list-item-subtitle>
          <v-list-item-subtitle v-if="item.memo">
            {{ item.memo }}
          </v-list-item-subtitle>
        </div>
        <div
          v-if="(item.textAuftrag || item.textTaetigkeit) && item.texttitle"
          style="min-height: 50px"
          class="pa-0"
          @click="
            hasFormDetail ? openFrame(true, item) : props.Anwesend && (item.menu = true)
          "
        >
          <v-row class="pa-0">
            <v-col cols="3" class="py-1">
              <v-list-item-subtitle v-if="item.textAuftrag"
                >{{ item.textAuftrag }}
              </v-list-item-subtitle> </v-col
            ><v-col cols="9" class="py-1">
              <v-list-item-subtitle v-if="item.auftrag"
                >{{ item.auftrag }}
              </v-list-item-subtitle>
            </v-col>
          </v-row>
          <v-row class="pa-0">
            <v-col cols="3" class="py-1">
              <v-list-item-subtitle v-if="item.textTaetigkeit"
                >{{ item.textTaetigkeit }}
              </v-list-item-subtitle> </v-col
            ><v-col cols="9" class="py-1">
              <v-list-item-subtitle v-if="item.taetigkeit">{{
                item.taetigkeit
              }}</v-list-item-subtitle>
            </v-col>
          </v-row>
        </div>
        <v-container
          v-if="(item.auftrag || item.taetigkeit) && !item.texttitle"
          class="pa-0 pt-2"
          style="min-height: 50px"
        >
          <div class="auftrag-row">
            <div v-if="item.textAuftrag || item.auftrag" class="auftrag-pair">
              <span v-if="item.textAuftrag" class="auftrag-label">
                {{ item.textAuftrag }}:
              </span>
              <span v-if="item.auftrag" class="auftrag-value">
                {{ item.auftrag }}
              </span>
            </div>

            <div v-if="item.textTaetigkeit || item.taetigkeit" class="auftrag-pair">
              <span v-if="item.textTaetigkeit" class="auftrag-label">
                {{ item.textTaetigkeit }}:
              </span>
              <span v-if="item.taetigkeit" class="auftrag-value">
                {{ item.taetigkeit }}
              </span>
            </div>
          </div>
        </v-container>

        <SubMasken
          v-if="item.buttonItems && item.buttonItems.length > 0"
          :buttonItems="item.buttonItems"
          :aic="item.aic ?? 0"
          :name="item.header ?? ''"
          :pers="pers ?? false"
        ></SubMasken>
        <slot name="itemAppend" v-bind:item="item" v-bind:index="index"></slot>
        <!-- <v-divider></v-divider> -->

        <v-list-item-action v-if="showQuittMsg">
          <v-checkbox
            v-if="item.aic"
            @update:modelValue="quittMsg(item.aic)"
            v-model="item.quittMsg"
            hide-details
          ></v-checkbox>
        </v-list-item-action>

        <v-menu
          v-if="props.Anwesend"
          v-model="item.menu"
          :attach="getListItemHtmlId(index, false)"
          offset="80"
        >
          <v-card
            v-if="item.menu && (item.mail || item.telefon || item.handy)"
            width="350"
          >
            <v-progress-linear
              :indeterminate="true"
              v-if="uiData.showLoading"
              color="dvhSlider"
            ></v-progress-linear>
            <v-container class="pa-0" v-if="uiData.initialized">
              <v-sheet xs12 v-if="item.mail">
                {{ begriffBezeichnung("EMail") }}
                <a :href="'mailto: ' + item.mail">{{ item.mail }}</a>
              </v-sheet>
              <v-sheet xs12 v-if="item.telefon">
                {{ begriffBezeichnung("Tel") }}:
                <a v-if="item.telefon" :href="item.telHref">
                  {{ item.telefon }} / {{ item.dw }}</a
                >
              </v-sheet>
              <v-sheet v-if="!item.telefon && item.dw" xs12>
                {{ begriffBezeichnung("DW") }}: {{ item.dw }}</v-sheet
              >
              <v-sheet xs12 v-if="item.handy"
                >{{ begriffBezeichnung("Firmenhandy") }}:
                <a :href="item.handyHref">{{ item.handy }}</a></v-sheet
              >
            </v-container>
            <v-card-actions class="pa-0">
              <v-spacer></v-spacer>
              <v-btn
                variant="flat"
                @click.stop="item.menu = false"
                icon="mdi-close"
                color="blue darken-1"
              >
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-list-item>
    </v-list>
    {{ resetGroupHeader() }}
    <v-list
      v-if="(props.Anwesend || props.showFilter) && subHeader && uiData.initialized"
      lines="three"
      subheader
      min-height="300"
    >
      <template v-for="(item, index) in pagedItems" :key="'grp' + index">
        <div
          class="dvhSubMenu lighten-2"
          :key="'grp' + index"
          v-if="showGroupHeader(item)"
        >
          <v-list-subheader color="black" v-if="item.group">
            <v-icon v-if="item.group">mdi-circle-small</v-icon>{{ item.group }}
          </v-list-subheader>
        </div>

        <v-card class="ma-0 pa-0" variant="elevated">
          <v-list-item
            :key="'men' + index"
            :id="getListItemHtmlId(index, true)"
            :ripple="props.Anwesend || hasFormDetail"
            :tabindex="props.Anwesend || hasFormDetail ? 0 : -1"
            :aria-disabled="!(props.Anwesend || hasFormDetail)"
            variant="outlined"
            tile
            :class="['pr-0', { 'no-click': !(props.Anwesend || hasFormDetail) }]"
          >
            <template #prepend>
              <div class="d-none d-sm-flex">
                <v-icon v-if="item.ampel" size="x-large" :color="item.color" class="mr-2">
                  mdi-circle-slice-8
                </v-icon>

                <v-img
                  v-else-if="item.icon"
                  :src="item.icon"
                  max-width="24"
                  max-height="24"
                  class="mr-2"
                />

                <v-avatar
                  v-else-if="
                    showAvatar && props.showAvatarLeft && item.avatar !== undefined
                  "
                  size="32"
                  class="mr-2"
                >
                  <v-img v-if="item.avatar" :src="item.avatar" />
                  <v-icon v-else size="32" color="grey">mdi-account-circle</v-icon>
                </v-avatar>
              </div>
            </template>
            <template v-slot:append>
              <v-list-item-action class="flex-column align-end d-none d-sm-flex">
                <v-avatar
                  v-if="!props.showAvatarLeft && props.showAvatar"
                  @click="openFrame(true, item)"
                  class="pr-2"
                >
                  <v-img v-if="item.avatar" :src="item.avatar" size="48" />
                  <v-icon v-if="!item.avatar" size="48" color="grey"
                    >mdi-account-circle</v-icon
                  >
                </v-avatar>
                <v-checkbox
                  v-if="showSelect && item.aic"
                  @update:modelValue="selectChange(item)"
                  v-model="item.select"
                  class="pa-0"
                  hide-details
                ></v-checkbox>
                <SpeedDial
                  v-if="props.showSpeedDial"
                  :aic="item.aic"
                  :modell="item.modell"
                  :modell1="item.modell1"
                  :printItems="props.druckItems"
                  :exportItems="props.exportItems"
                  :print="props.print"
                  :pdf="item.pdf"
                  :edit="item.edit"
                  :setEdit="false"
                  direction="left"
                  :pers="pers"
                ></SpeedDial>
              </v-list-item-action>
            </template>
            <v-list-item-title
              class="d-flex justify-content-between align-center w-100"
              @click="
                hasFormDetail
                  ? openFrame(true, item)
                  : props.Anwesend && (item.menu = true)
              "
            >
              <!-- Linke Seite: Icon/Bild/Avatar + Titel -->
              <div class="d-flex align-center">
                <!-- Mobile Icon/Bild/Avatar -->
                <div class="d-flex align-center d-sm-none mr-2">
                  <v-icon v-if="item.ampel" size="large" :color="item.color" class="mr-2">
                    mdi-circle-slice-8
                  </v-icon>

                  <v-img
                    v-else-if="item.icon"
                    :src="item.icon"
                    max-width="20"
                    max-height="20"
                    class="mr-2"
                  />

                  <v-avatar
                    v-else-if="
                      showAvatar && props.showAvatarLeft && item.avatar !== undefined
                    "
                    size="24"
                  >
                    <v-img v-if="item.avatar" :src="item.avatar" />
                    <v-icon v-else size="24" color="grey">mdi-account-circle</v-icon>
                  </v-avatar>
                </div>

                <!-- Titel -->
                {{ item.header }}
              </div>

              <!-- Rechte Seite: Mobile Inline (Checkbox + SpeedDial + Avatar nebeneinander) -->
              <div class="d-flex align-center d-sm-none ml-auto">
                <v-avatar
                  v-if="showAvatar && !props.showAvatarLeft && props.showAvatar"
                  class="mr-2"
                >
                  <v-img v-if="item.avatar" :src="item.avatar" size="36" />
                  <v-icon v-else size="36" color="grey">mdi-account-circle</v-icon>
                </v-avatar>

                <v-checkbox
                  v-if="showSelect && item.aic"
                  v-model="item.select"
                  @update:modelValue="selectChange(item)"
                  hide-details
                  class="mr-2"
                ></v-checkbox>

                <SpeedDial
                  v-if="props.showSpeedDial"
                  :aic="item.aic"
                  :modell="item.modell"
                  :modell1="item.modell1"
                  :exportItems="props.exportItems"
                  :printItems="props.druckItems"
                  :print="props.print"
                  :editDialog="item.edit"
                  :setEdit="false"
                  direction="left"
                  :pers="pers"
                ></SpeedDial>
              </div>
            </v-list-item-title>
            <v-list-item-subtitle
              class="py-5"
              v-if="(item.texttitle || item.textsubtitel) && !props.Anwesend"
              @click="openFrame(true, item)"
            >
              <v-row v-if="item.texttitle">
                <v-col cols="3" class="py-1"> {{ item.texttitle }}</v-col
                ><v-col cols="9" class="py-1">
                  {{ item.title }}
                </v-col>
              </v-row>

              <v-row class="pa-0" v-if="item.textsubtitel">
                <v-col cols="3" class="py-1"> {{ item.textsubtitel }}</v-col
                ><v-col cols="9" class="py-1">
                  {{ item.subtitel }}
                </v-col>
              </v-row>
            </v-list-item-subtitle>
            <div
              style="min-height: 50px"
              @click="
                hasFormDetail
                  ? openFrame(true, item)
                  : props.Anwesend && (item.menu = true)
              "
            >
              <v-list-item-subtitle v-if="item.title && !item.texttitle">
                {{ item.title }}</v-list-item-subtitle
              >
              <v-list-item-subtitle v-if="item.subtitel && !item.textsubtitel"
                >{{ item.subtitel }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.text"
                >{{ item.text }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.memo">
                {{ item.memo }}
              </v-list-item-subtitle>
            </div>
            <div
              v-if="(item.textAuftrag || item.textTaetigkeit) && item.texttitle"
              style="min-height: 50px"
              class="pa-0"
            >
              <v-row class="pa-0">
                <v-col cols="3" class="py-1">
                  <v-list-item-subtitle v-if="item.textAuftrag"
                    >{{ item.textAuftrag }}
                  </v-list-item-subtitle> </v-col
                ><v-col cols="9" class="py-1">
                  <v-list-item-subtitle v-if="item.auftrag"
                    >{{ item.auftrag }}
                  </v-list-item-subtitle>
                </v-col>
              </v-row>
              <v-row class="pa-0">
                <v-col cols="3" class="py-1">
                  <v-list-item-subtitle v-if="item.textTaetigkeit"
                    >{{ item.textTaetigkeit }}
                  </v-list-item-subtitle> </v-col
                ><v-col cols="9" class="py-1">
                  <v-list-item-subtitle v-if="item.taetigkeit">{{
                    item.taetigkeit
                  }}</v-list-item-subtitle>
                </v-col>
              </v-row>
            </div>
            <v-container
              v-if="(item.auftrag || item.taetigkeit) && !item.texttitle"
              class="pa-0 pt-2"
              style="min-height: 50px"
              @click="
                hasFormDetail
                  ? openFrame(true, item)
                  : props.Anwesend && (item.menu = true)
              "
            >
              <div class="auftrag-row">
                <div v-if="item.textAuftrag || item.auftrag" class="auftrag-pair">
                  <span v-if="item.textAuftrag" class="auftrag-label">
                    {{ item.textAuftrag }}:
                  </span>
                  <span v-if="item.auftrag" class="auftrag-value">
                    {{ item.auftrag }}
                  </span>
                </div>

                <div v-if="item.textTaetigkeit || item.taetigkeit" class="auftrag-pair">
                  <span v-if="item.textTaetigkeit" class="auftrag-label">
                    {{ item.textTaetigkeit }}:
                  </span>
                  <span v-if="item.taetigkeit" class="auftrag-value">
                    {{ item.taetigkeit }}
                  </span>
                </div>
              </div>
            </v-container>
            <SubMasken
              v-if="item.buttonItems && item.buttonItems.length > 0"
              :buttonItems="item.buttonItems"
              :aic="item.aic ?? 0"
              :name="item.title ?? ''"
              :pers="pers ?? false"
            ></SubMasken>
            <slot name="itemAppend" v-bind:item="item" v-bind:index="index"></slot>
            <v-menu
              v-if="props.Anwesend && !props.showSpeedDial"
              v-model="item.menu"
              :attach="getListItemHtmlId(index, false)"
              offset="80"
            >
              <v-card
                v-if="item.menu && (item.mail || item.telefon || item.handy)"
                width="350"
              >
                <v-progress-linear
                  :indeterminate="true"
                  v-if="uiData.showLoading"
                  color="dvhSlider"
                ></v-progress-linear>
                <v-container class="pa-0" v-if="uiData.initialized">
                  <v-sheet xs12 v-if="item.mail">
                    {{ begriffBezeichnung("EMail") }}
                    <a :href="'mailto: ' + item.mail">{{ item.mail }}</a>
                  </v-sheet>

                  <v-sheet xs12 v-if="item.telefon">
                    {{ begriffBezeichnung("Tel") }}:
                    <a v-if="item.telefon" :href="item.telHref">
                      {{ item.telefon }} / {{ item.dw }}</a
                    >
                  </v-sheet>
                  <v-sheet v-if="!item.telefon && item.dw" xs12>
                    {{ begriffBezeichnung("DW") }}: {{ item.dw }}</v-sheet
                  >
                  <v-sheet xs12 v-if="item.handy"
                    >{{ begriffBezeichnung("Firmenhandy") }}:
                    <a :href="item.handyHref">{{ item.handy }}</a></v-sheet
                  >
                </v-container>
                <v-card-actions class="pa-0">
                  <v-spacer></v-spacer>
                  <v-btn variant="text" @click.stop="item.menu = false" icon="mdi-cancel">
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-list-item-action v-if="showQuittMsg">
              <v-checkbox
                v-if="item.aic"
                @update:modelValue="quittMsg(item.aic)"
                v-model="item.quittMsg"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
        </v-card>
      </template>
    </v-list>
    <v-list
      lines="three"
      v-if="!props.Anwesend && !props.showFilter && uiData.initialized"
      dense
      min-height="300"
    >
      <v-list-item
        v-for="(item, index) in pagedItems"
        :key="'c' + index"
        :id="getListItemHtmlId(index, true)"
      >
        <v-list-item-action v-if="edit && item.aic">
          <v-checkbox
            @update:modelValue="selectChange(item)"
            class="pa-0"
            v-model="item.select"
          ></v-checkbox>
        </v-list-item-action>
        <template v-slot:prepend>
          <v-icon v-if="item.ampel" size="x-large" :color="item.color"
            >mdi-circle-slice-8</v-icon
          >
          <v-icon
            v-if="item.icon && !subForm"
            :color="item.color"
            :icon="item.icon"
          ></v-icon
          >&nbsp;
          <v-btn
            class="pa-0 mr-5"
            v-if="subForm"
            @click="openFrame(false, item)"
            :prepend-icon="item.icon"
            variant="text"
          >
            <template v-slot:prepend>
              <v-icon size="x-large" :color="item.color"></v-icon>
            </template>
          </v-btn>
        </template>
        <v-btn
          density="comfortable"
          size="large"
          class="ma-5"
          v-if="item.pdf && item.checkbox"
          @click="onShowPdf(item.pdf)"
          variant="outlined"
          ><v-icon>mdi-file-pdf-box</v-icon>{{ item.pdf.name }}</v-btn
        >
        <v-list-subheader v-if="item.header" @click="openFrame(true, item)">{{
          item.header
        }}</v-list-subheader>

        <div v-if="(item.texttitle || item.textsubtitel) && !props.Anwesend">
          <v-row class="pa-0" v-if="item.texttitle">
            <v-col cols="3" class="py-1">
              <v-list-item-subtitle> {{ item.texttitle }}</v-list-item-subtitle> </v-col
            ><v-col cols="9" class="py-1">
              <v-list-item-subtitle style="text-align: right"
                >{{ item.title }}
              </v-list-item-subtitle>
            </v-col>
          </v-row>
          <v-row class="pa-0" v-if="item.textsubtitel">
            <v-col cols="3" class="py-1">
              <v-list-item-subtitle>
                {{ item.textsubtitel }}</v-list-item-subtitle
              > </v-col
            ><v-col cols="9" class="py-1">
              <v-list-item-subtitle style="text-align: right"
                >{{ item.subtitel }}
              </v-list-item-subtitle>
            </v-col>
          </v-row>
        </div>
        <v-list-item-title v-if="item.title && !item.texttitle">{{
          item.title
        }}</v-list-item-title>
        <v-list-item-subtitle v-if="item.subtitel && !item.textsubtitel">{{
          item.subtitel
        }}</v-list-item-subtitle>

        <v-list-item-subtitle v-if="item.text" class="wrap-text"
          >{{ item.text }}
        </v-list-item-subtitle>
        <v-divider></v-divider>

        <v-list-item-action v-if="showQuittMsg">
          <v-checkbox
            v-if="item.aic"
            @update:modelValue="quittMsg(item.aic)"
            v-model="item.quittMsg"
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-action v-if="props.showSpeedDial">
          <SpeedDial
            :aic="item.aic"
            :modell="item.modell"
            :modell1="item.modell1"
            :printItems="props.druckItems"
            :exportItems="props.exportItems"
            :print="props.print"
            :pdf="item.pdf"
            :editDialog="item.edit"
            :setEdit="false"
            direction="left"
            :pers="pers"
          ></SpeedDial>
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>

    <v-pagination
      v-if="pages > 1"
      rounded="circle"
      total-visible="8"
      :length="pages"
      v-model="currentPage"
      :tile="true"
      @update:model-value="updatePagedItems"
      variant="elevated"
    ></v-pagination>
  </v-card>
</template>
<style scoped>
.auftrag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.auftrag-pair {
  flex: 1 1 220px;
  display: flex;
  gap: 6px;
  align-items: baseline;
}

.auftrag-label,
.auftrag-value {
  white-space: nowrap;
}
.ampel-icon {
  border-radius: 0 !important;
  overflow: visible;
  display: flex;
  align-items: center;
}

.dvhSubMenu {
  background-color: #e8f1f7 !important;
  margin: 10px;
}
.v-img {
  border-radius: 50%;
  padding: 15px;
}
.baseList {
  /* min-height: 300px;*/
  height: 100%;
  width: 100%;
  min-width: 100%;
  margin: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
  display: inline-block;
  vertical-align: top-left;
  overflow-y: auto;
}
.wrap-text {
  white-space: normal;
  word-break: break-word; /* Falls lange Wörter umbrechen sollen */
}
.no-click {
  cursor: default;
}
.no-click:hover {
  background-color: inherit !important;
}
</style>
